<template>
  <!--====== Section 5: 어떤 결과물 + Section 6: 왜 AI Studio인가 ======-->
  <section class="appie-about-8-area pt-100 pb-100">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="appie-section-title mb-30 text-center">
            <h3 class="appie-title">어떤 결과물을 만들어주나요?</h3>
            <p>웹 하나 만들면, 앱까지 자연스럽게 이어집니다.</p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6">
          <div class="appie-single-service-2 appie-single-service-about mt-30 wow animated fadeInUp text-center" data-wow-duration="2000ms" data-wow-delay="200ms">
            <div class="icon">
              <i class="fal fa-globe"></i>
            </div>
            <h4 class="title">웹 제작</h4>
            <p>기업 홈페이지 · 서비스 소개 웹사이트 · 관리자 페이지 · 웹 기반 서비스</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="appie-single-service-2 appie-single-service-about item-2 mt-30 wow animated fadeInUp text-center" data-wow-duration="2000ms" data-wow-delay="400ms">
            <div class="icon">
              <i class="fal fa-mobile-alt"></i>
            </div>
            <h4 class="title">앱 제작</h4>
            <p>안드로이드 / iOS 앱 · 웹뷰 앱 · 하이브리드 앱</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="appie-single-service-2 appie-single-service-about item-3 mt-30 wow animated fadeInUp text-center" data-wow-duration="2000ms" data-wow-delay="600ms">
            <div class="icon">
              <i class="fal fa-cogs"></i>
            </div>
            <h4 class="title">운영 지원</h4>
            <p>스토어 등록 대행 · 유지보수 · 서버 및 인프라 제공</p>
          </div>
        </div>
      </div>

      <!-- 왜 스윙투앱 AI Studio인가 -->
      <div class="row mt-80">
        <div class="col-lg-12">
          <div class="appie-section-title mb-30 text-center">
            <h3 class="appie-title">왜 스윙투앱 AI Studio인가</h3>
            <p>스윙투앱은 AI를 실험이 아니라, '납기와 품질을 맞추는 도구'로 씁니다.</p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-3 col-md-6">
          <div class="appie-single-service-2 appie-single-service-about item-4 mt-30 wow animated fadeInUp text-center" data-wow-duration="2000ms" data-wow-delay="200ms">
            <div class="icon">
              <i class="fal fa-calendar-check"></i>
            </div>
            <h4 class="title">2014년부터</h4>
            <p>앱 제작 전문 기업으로 오랜 경험을 보유하고 있습니다.</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="appie-single-service-2 appie-single-service-about mt-30 wow animated fadeInUp text-center" data-wow-duration="2000ms" data-wow-delay="400ms">
            <div class="icon">
              <i class="fal fa-layer-group"></i>
            </div>
            <h4 class="title">수천 개 앱 제작</h4>
            <p>다양한 분야의 앱 제작·운영 경험을 축적하고 있습니다.</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="appie-single-service-2 appie-single-service-about item-2 mt-30 wow animated fadeInUp text-center" data-wow-duration="2000ms" data-wow-delay="600ms">
            <div class="icon">
              <i class="fal fa-shield-check"></i>
            </div>
            <h4 class="title">스토어 정책 대응</h4>
            <p>플레이스토어·앱스토어 정책/운영까지 고려한 설계를 합니다.</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="appie-single-service-2 appie-single-service-about item-3 mt-30 wow animated fadeInUp text-center" data-wow-duration="2000ms" data-wow-delay="800ms">
            <div class="icon">
              <i class="fal fa-robot"></i>
            </div>
            <h4 class="title">AI 실전 활용 조직</h4>
            <p>AI를 '툴'로 쓰는 실전 개발 조직으로 생산성을 극대화합니다.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style>
.mt-80 {
  margin-top: 80px;
}
</style>
